import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g fill="currentColor">
      <path d="M3.406 6.09A2 2 0 0 0 2 8v16a2 2 0 0 0 2 2h21.518l-2.22-2H4V8h1.527zM28 22.852V8H11.505L9.284 6H28a2 2 0 0 1 2 2v16q-.001.297-.085.576z" />
      <path d="m24.84 20.006-1.48-1.332q.07-.036.14-.075a1 1 0 0 1 1.34 1.407M19.2 14.928l-1.55-1.395.02-.033a5 5 0 0 1 6.83-1.83.999.999 0 1 1-1 1.731 3 3 0 0 0-4.3 1.527M9.563 11.634l-.063.036a5 5 0 1 0 5 8.66 1 1 0 0 0-1-1.731 3 3 0 1 1-2.299-5.49zM1.378 4.264a1 1 0 0 1 1.339-1.486l26.52 23.878a1 1 0 0 1-1.339 1.487z" />
    </g>
  </svg>
);
const SvgIconClosedCaptioningOff = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconClosedCaptioningOff);
export default Memo;
